
<template>
  <div class="navigation">
    <nav id="nav" v-bind:class="{active : $store.state.nav}">
      <div id="closeContain" v-on:click="$store.commit('closeNav')">
        <CloseIcon/>
      </div>
      <div id="navcontainer">
        <router-link to="/">Home</router-link>
        <router-link to="/kitchen" v-if="$store.state.auth">Your Kitchen</router-link>
        <router-link to="/blog">Blog</router-link>
        <router-link to="/newblog" v-if="$store.state.admin">New Post</router-link>
        <router-link to="/login" v-if="!$store.state.auth">Login</router-link>
        <div id="signoutButton" v-if="$store.state.auth">
          <button v-on:click="onLogout()">Logout</button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import CloseIcon from 'icons/Close'
import auth from '../mixins/auth'
import router from '../router'

export default {
  name: 'navigation',
  components: {
    CloseIcon
  },
  mixins: [auth],
  data() {
    return {
    }
  },
  methods: {
    onLogout() {
      window.HRS_LOGGEDOUT = true
      this.logout()
      this.$store.commit('closeNav')
      router.push({ path: '/' })
    },
  }
}

</script>
<style lang="scss" scoped>
nav {
  z-index: 9;
  transform: translate(310px);
  transition: transform 0.3s ease;
  text-align: right;
  font-size: 30px;
  position: fixed;
  width: 250px;
  right: 0;
  background-color: #eaeaea;
  top: 0;
  bottom: 0;
  padding: 30px;
  &.active {
    transform: translate(0px);
  }

  #navcontainer {
    font-size:28px;
    text-align: left;
    display: grid;
    grid-template-rows: 1fr;
  }
  a {
    padding: 0 0 10px 0;
    font-weight: bold;
    color: #2c3e50;
    text-decoration: none;
    &.router-link-exact-active {
      color: var(--amazonOrange);
    }
    &[disabled="disabled"] {
      color: --grey;
      pointer-events: none;
    }
    &:hover {
      color: var(--amazonOrange);
    }
  }
}

@media (max-width: 350px) {
  nav {
    width: calc(100vw - 60px);
  }
}

#signoutButton {
  button {
    text-align: left;
    font-size: 28px;
    font-weight: 700;
    padding: 0;
    font-family: 'Nanum Gothic';
    text-transform: none;
    border: none;
    cursor: pointer;
    &:hover {
      color: var(--amazonOrange);
    }
  }
}
</style>
